// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"8014a015","676":"b5fd0b70","925":"5c0d2a33"}[chunkId] + ".chunk.css";
};